/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgFontSizeBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <path
      d="M16.479 21.4509L9.953 2.33792C9.91921 2.23932 9.85546 2.15374 9.77065 2.09316C9.68585 2.03257 9.58423 2 9.48 2C9.37577 2 9.27415 2.03257 9.18935 2.09316C9.10454 2.15374 9.04079 2.23932 9.007 2.33792L2.5 21.4509M4.88306 14.4509H14.0901M1 21.4509H4.02M14.979 21.4509H18M23 21.451L18.877 9.37295C18.8432 9.27435 18.7794 9.18878 18.6946 9.12819C18.6098 9.0676 18.5082 9.03503 18.404 9.03503C18.2997 9.03503 18.1981 9.0676 18.1133 9.12819C18.0285 9.18878 17.9648 9.27435 17.931 9.37295L16.043 14.916M17.42 16.4509H21.294M22.016 21.4509H24"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgFontSize = wrapIcon(SvgFontSizeBase);
export default SvgFontSize;
